import React, { useEffect, useState } from "react";
import './styles.css'
import CommonScreenContent from "../../../components/screen/common-screen-content/commonScreenContent";
import CommonInputRow from "../../../components/input/common-input-row/commonInputRow";
import ScreenLabel from "../../../components/label/screen-label/screenLabel";
import Loader from '../../../components/loader/loader.component'
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useDispatch, useSelector } from 'react-redux'
import { userBusinessListRequest } from '../../../redux/business/business.action'
import { businessLocationListRequest } from '../../../redux/business-location/businessLocation.action'
import { visitorListRequest, visitorExitRequest, visitorExitRequestStatus } from '../../../redux/visitor/visitor.action'
import FormFieldLabel from "../../../components/label/form-field-label/formFieldLabel";
import Select from 'react-select'
import { API_CONSTANTS, APP_CONSTANTS } from "../../../utils/AppConstants";
import { displayConsoleLog, displayErrorToast, displaySuccessToast, isEmpty, isLoggedInUserBusiness, isLoggedInUserEmployee, isNull } from "../../../utils/Utils";
import TopButton from "../../../components/button/top-button/topButton";
import Modal from 'react-bootstrap/Modal';
import moment from "moment";
import { config } from "../../../config";

const VisitorBook = props => {
    const dispatch = useDispatch()
    const [isLoading, setLoading] = useState(false)
    const { user, employeeSelectedBusiness, employeeSelectedLocation } = useSelector((state) => state.user)
    const { userBusinessListSuccess, userBusinessListError } = useSelector(state => state.business)
    const { businessLocationListSuccess, businessLocationListError } = useSelector(state => state.businessLocation)
    const [selectedBusiness, setSelectedBusiness] = useState()
    const [selectedLocation, setSelectedLocation] = useState()
    const { visitorListSuccess, visitorListError,
        visitorExitSuccess, visitorExitError, visitorExitReqStatus } = useSelector((state) => state.visitor)
    const [showExitModal, setShowExitModal] = useState(false)
    const [showDetailModal, setShowDetailModal] = useState(false)
    const [selectedRecord, setSelectedRecord] = useState(null)

    useEffect(() => {
        if (isLoggedInUserBusiness(user)) {
            sessionStorage.setItem(APP_CONSTANTS.SCREEN.VISITOR_LIST_SCREEN, true)
            fetchBusinessList()
        } else if (isLoggedInUserEmployee(user)) {
            getVisitorList()
        }
    }, [])

    const fetchBusinessList = () => {
        setLoading(true)
        const data = {
            userId: user.data.userDetails.userId
        }
        dispatch(userBusinessListRequest(data))
    }

    const fetchBusinessLocation = () => {
        if (!isEmpty(selectedBusiness)) {
            setLoading(true)
            dispatch(businessLocationListRequest(selectedBusiness.businessId))
        }
    }

    useEffect(() => {
        if (visitorExitReqStatus === API_CONSTANTS.SUCCESS_STATUS) {
            setLoading(false)
            displaySuccessToast(visitorExitSuccess.message)
            getVisitorList()
        } else if (visitorExitReqStatus === API_CONSTANTS.ERROR_STATUS) {
            setLoading(false)
            displayErrorToast(visitorExitError.message)
        }
        if (visitorExitReqStatus?.length) {
            dispatch(visitorExitRequestStatus(''))
        }
    }, [visitorExitSuccess, visitorExitError, visitorExitReqStatus])

    useEffect(() => {
        if (!isEmpty(userBusinessListSuccess)) {
            setLoading(false)
            if (sessionStorage.getItem(APP_CONSTANTS.SCREEN.VISITOR_LIST_SCREEN) === 'true') {
                sessionStorage.setItem(APP_CONSTANTS.SCREEN.VISITOR_LIST_SCREEN, false)
                setSelectedBusiness(userBusinessListSuccess.data[0])
            }
        } else if (!isEmpty(userBusinessListError)) {
            setLoading(false)
        }
    }, [userBusinessListSuccess, userBusinessListError])

    useEffect(() => {
        if (!isEmpty(businessLocationListSuccess)) {
            setLoading(false)
            setSelectedLocation(businessLocationListSuccess.data[0])
        } else if (!isEmpty(businessLocationListError)) {
            setLoading(false)
        }
    }, [businessLocationListSuccess, businessLocationListError])

    useEffect(() => {
        if (!isEmpty(visitorListSuccess)) {
            setLoading(false)
        } else if (!isEmpty(visitorListError)) {
            setLoading(false)
        }
    }, [visitorListSuccess, visitorListError])

    useEffect(() => {
        if (isLoggedInUserBusiness(user) === true && !isNull(selectedBusiness)) {
            fetchBusinessLocation()
        }
    }, [selectedBusiness])

    useEffect(() => {
        if (isLoggedInUserBusiness(user) === true && !isNull(selectedLocation)) {
            getVisitorList()
        }
    }, [selectedLocation])

    const getVisitorList = () => {
        if (isLoggedInUserBusiness(user) && (isEmpty(selectedBusiness) || isEmpty(selectedLocation))) {
            displayErrorToast('Business or business location not selected')
        } else if (isLoggedInUserEmployee(user) && (isEmpty(employeeSelectedBusiness) || isEmpty(employeeSelectedLocation))) {
            displayErrorToast('Business or business location not selected')
        } else {
            setLoading(true)
            const data = {
                businessId: isLoggedInUserBusiness(user) ? selectedBusiness.businessId : employeeSelectedBusiness,
                locationId: isLoggedInUserBusiness(user) ? selectedLocation.locationId : employeeSelectedLocation
            }
            dispatch(visitorListRequest(data))
        }
    }

    const handleMarkExitClick = e => {
        setSelectedRecord(e)
        setShowExitModal(true)
    }

    const handleInformationClick = e => {
        setSelectedRecord(e)
        setShowDetailModal(true)
    }

    const handleExitClick = () => {
        setLoading(true)
        const data = {
            visitorBookId: selectedRecord.visitorBookId
        }
        dispatch(visitorExitRequest(data))
        setShowDetailModal(false)
        setShowExitModal(false)
    }

    const isValidNumber = text => {
        if (isEmpty(text))
            return false
        if (text === 0)
            return false
        return true
    }

    return (
        <>
            <CommonScreenContent>
                <CommonInputRow className='margin-top-10 margin-bottom-10'>
                    <ScreenLabel label='Visitor Book' />
                    <TopButton label='Refresh' onClick={() => { getVisitorList() }} />
                </CommonInputRow>
                {isLoggedInUserBusiness(user) === true && <CommonInputRow>
                    <div className="select-half-width">
                        <FormFieldLabel className='up-bold-label' label='Select Business' />
                        {!isEmpty(userBusinessListSuccess) && !isEmpty(userBusinessListSuccess.data) && <Select
                            className='select-full-width-no-border'
                            value={selectedBusiness}
                            getOptionLabel={e => e.businessName}
                            getOptionValue={e => e}
                            options={userBusinessListSuccess.data}
                            placeholder='Select Business'
                            onChange={e => setSelectedBusiness(e)} />}
                        {!isEmpty(userBusinessListError) && <div className="p-text">{userBusinessListError.message}</div>}
                    </div>
                    {!isEmpty(selectedBusiness) && <div className="select-half-width">
                        <FormFieldLabel className='up-bold-label' label='Select Location' />
                        {!isEmpty(businessLocationListSuccess) && !isEmpty(businessLocationListSuccess.data) && <Select
                            className='select-full-width-no-border'
                            value={selectedLocation}
                            getOptionLabel={e => e.name}
                            getOptionValue={e => e}
                            options={businessLocationListSuccess.data}
                            placeholder='Select Location'
                            onChange={e => setSelectedLocation(e)} />}
                        {!isEmpty(businessLocationListError) && <div className="p-text">{businessLocationListError.message}</div>}
                    </div>}
                </CommonInputRow>}
                {!isEmpty(visitorListSuccess) && !isEmpty(visitorListSuccess.data) && <div className="table-scroll-container">
                    <table className="table table-hover mt-4">
                        <thead>
                            <tr>
                                <th scope="col">Name</th>
                                <th scope="col" className="text-center">Contact</th>
                                <th scope="col" className="text-center">Host Name</th>
                                <th scope="col" className="text-center">Date</th>
                                <th scope="col" className="text-center">Time In</th>
                                <th scope="col" className="text-center">Time Out</th>
                                <th scope="col" className="text-center">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {visitorListSuccess.data.map(element => (
                                <tr className="loc-table-row-container">
                                    <td>{!isEmpty(element.name) ? element.name : ''}</td>
                                    <td className="text-center">{isValidNumber(element.mobile) ? element.mobile : '-'}</td>
                                    <td className="text-center">{!isEmpty(element.hostName) ? element.hostName : '-'}</td>
                                    <td className="text-center">{moment(element.createdOn).utc().local().format('DD MMM YYYY')}</td>
                                    <td className="text-center">{moment(element.createdOn).utc().local().format('hh:mm a')}</td>
                                    <td className="text-center">{element.timeOut ? moment(element.timeOut).utc().local().format('hh:mm a') : '-'}</td>
                                    <td className="text-center">
                                        <div className="loc-list-button-container">
                                            {!element.timeOut && <div className="loc-list-button" onClick={() => { handleMarkExitClick(element) }}><div className="tr-action-btn">Mark Exit</div></div>}
                                            <div className="loc-list-button" onClick={() => { handleInformationClick(element) }}><div className="tr-action-btn">View Details</div></div>
                                        </div>
                                    </td>
                                </tr>
                            ))}

                        </tbody>
                    </table>
                </div>}
                {!isEmpty(visitorListError) && <div className="content-error">{visitorListError.message}</div>}
            </CommonScreenContent>
            <Modal
                onHide={() => { setShowExitModal(false) }}
                show={showExitModal}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Warning
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div>Do you want to mark select visitor exit?</div>
                </Modal.Body>
                <Modal.Footer>
                    <div className="mark-exit-btn" onClick={() => { handleExitClick() }}>Mark Exit</div>
                </Modal.Footer>
            </Modal>
            <Modal
                onHide={() => { setShowDetailModal(false) }}
                show={showDetailModal}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Information
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {selectedRecord && <div>
                        <div className="vb-img-parent-container">
                            <div className="vb-img-container">
                                <img src={`${config.imageUrl}${selectedRecord.image}`} className='img' />
                            </div>
                        </div>
                        <h1 className="vb-name-label">{selectedRecord.name ? selectedRecord.name : ''}</h1>
                        {isValidNumber(selectedRecord.mobile) && <div> <FormFieldLabel className='up-bold-label' label='Contact Number' />
                            <div>{selectedRecord.mobile ? selectedRecord.mobile : ''}</div>
                        </div>}
                        {!isEmpty(selectedRecord.address) && <div>
                            <FormFieldLabel className='up-bold-label' label='Address' />
                            <div>{selectedRecord.address}</div>
                        </div>}
                        {!isEmpty(selectedRecord.emailId) && <div>
                            <FormFieldLabel className='up-bold-label' label='Email Id' />
                            <div>{selectedRecord.emailId}</div>
                        </div>}
                        {!isEmpty(selectedRecord.vehicleInformation) && <div>
                            <FormFieldLabel className='up-bold-label' label='Vehicle Information' />
                            <div>{selectedRecord.vehicleInformation}</div>
                        </div>}
                        {!isEmpty(selectedRecord.visitorIdCode) && <div>
                            <FormFieldLabel className='up-bold-label' label='Visitor Id' />
                            <div>{selectedRecord.visitorIdCode}</div>
                        </div>}
                        {!isEmpty(selectedRecord.companyName) && <div>
                            <FormFieldLabel className='up-bold-label' label='Company Name' />
                            <div>{selectedRecord.companyName}</div>
                        </div>}
                        {!isEmpty(selectedRecord.purpose) && <div>
                            <FormFieldLabel className='up-bold-label' label='Visiting Purpose' />
                            <div>{selectedRecord.purpose}</div>
                        </div>}
                        {!isEmpty(selectedRecord.hostName) && <div>
                            <FormFieldLabel className='up-bold-label' label='Host Name' />
                            <div>{selectedRecord.hostName}</div>
                        </div>}
                        {isValidNumber(selectedRecord.hostPhoneNumber) && <div>
                            <FormFieldLabel className='up-bold-label' label='Host Contact' />
                            <div>{selectedRecord.hostPhoneNumber}</div>
                        </div>}
                        {!isEmpty(selectedRecord.hostEmailId) && <div>
                            <FormFieldLabel className='up-bold-label' label='Host Email Id' />
                            <div>{selectedRecord.hostEmailId}</div>
                        </div>}
                        <FormFieldLabel className='up-bold-label' label='Entry Date & Time' />
                        <div>{moment(selectedRecord.createdOn).utc().local().format('DD MMM YYYY hh:mm a')}</div>
                        {!isEmpty(selectedRecord.timeOut) && <div>
                            <FormFieldLabel className='up-bold-label' label='Exit Date & Time' />
                            <div>{moment(selectedRecord.timeOut).utc().local().format('DD MMM YYYY hh:mm a')}</div>
                        </div>}
                    </div>}
                </Modal.Body>
                <Modal.Footer>
                    {selectedRecord && !selectedRecord.timeOut && <div className="mark-exit-btn" onClick={() => { handleExitClick() }}>Mark Exit</div>}
                </Modal.Footer>
            </Modal>
            <ToastContainer />
            <Loader active={isLoading} text='Please wait...' />
        </>
    )
}

export default VisitorBook